import { render, staticRenderFns } from "./AudioSettings.vue?vue&type=template&id=0da5b41b"
import script from "./AudioSettings.vue?vue&type=script&lang=js"
export * from "./AudioSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports